import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface RouterLinkProps {
  to?: string;
  onClick?: AnyFunc;
  className?: string;
  children?: TypeMePlease;
  target?: string;
}

export default function RouterLink(props: RouterLinkProps) {
  const navigate = useNavigate();

  const click = (e) => {
    e.preventDefault();
    navigate(props.to);
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <a href={props.to} className={props.className} onClick={click}>
      {props.children}
    </a>
  );
}
